import React, { useRef, useState } from "react";
import { Box, Button, Grid2 } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetail } from "../../../Actions/UserDetailAction";
import { ToastError, ToastSuccess } from "../../../CustomToaster/CustomToaster";
import api from "../../../utils/axiosInstance";
import { resendOtp } from "../../../Services/auth";
import { InputError } from "../../Errors/ErrorText";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'var(--color-BasicBg)',
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
};
function TwoFAProfile() {
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down("md"));

    const [copied, setcopied] = useState(false);
    const [method, setMethod] = useState(null);
    const [qrCode, setQrCode] = useState(null);
    const [googleAuthSecret, setGoogleAuthSecret] = useState(null);
    const [timeExpired, setTimerExpired] = useState(false);
    const [targetTime, setTargetTime] = useState();
    const [enableAttempt, setEnableAttempt] = useState(false);
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [password, setPassword] = useState("");
    const [disabled, setDisabled] = useState(false)
    const [errors, setErrors] = useState({
        otp: "",
        password: ""
    });
    const [block, setBlock] = useState(false)

    //modal
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    //modal1
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);

    //modal1
    const [open2, setOpen2] = React.useState(false);
    const handleOpenVerifyModal = () => setOpen2(true);
    const handleCloseVerifyModal = () => {
        setPassword('');
        setErrors({});
        setOpen2(false);
    }

    const [pop7, setpop7] = useState(false);

    const handlePopOpen7 = async () => {
        setpop7(true);
    };

    const handlePopClose7 = async () => {
        setpop7(false);
    };



    const { userDetailData, userDetailLoading } = useSelector((state) => state.user);
    const { userData } = useSelector((state) => state.auth);
    const [userDetail, setUserDetail] = useState({})

    const dispatch = useDispatch()
    const inputRefs = useRef([]);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const handleClickShowConfirmPassword = () =>
        setShowConfirmPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        dispatch(getUserDetail());
    }, [])

    useEffect(() => {
        if (!userDetailLoading) {
            setUserDetail(userDetailData)
        }
    }, [userDetailLoading, userDetailData])

    const handlecopystate = () => {
        setcopied(true);
    }
    const handleCopy = () => {
        navigator.clipboard.writeText(googleAuthSecret);
        ToastSuccess({ message: "Copied Successfull" })
    };

    // setCopied(true);

    const validatPassword = () => {
        let formErrors = {};
        let isValid = true;

        if (!password) {
            formErrors.password = "Password is required";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const [passwordLoading, setPasswordLoading] = useState(false)
    const handleOpenTwoFA = async (type, method) => {
        if (validatPassword()) {


            try {

                setEnableAttempt(false);
                setMethod(method);
                setPasswordLoading(true)
                const { data } = await api.post(`/user/enable-twofa`, {
                    method,
                    type: type,
                    verifyType: "Twofa-Enable",
                    currentPassword: password
                });
                if (data?.success) {
                    setQrCode(data.result.qrCode);
                    setGoogleAuthSecret(data.result.googleAuthSecret);
                    setTargetTime(data?.result?.time);

                    setTimerExpired(false);
                    if (method === "email") {
                        handleOpen1();
                    } else {
                        if (data?.result?.googleAuthSecret === null) {
                            // handleOpen1();
                            handleOpen();
                        } else {
                            handleOpen();
                        }
                    }

                    setEnableAttempt(false);
                    setPasswordLoading(false)
                    handleCloseVerifyModal();


                } else {
                    if (data?.result?.blocked === true) {
                        setTargetTime(data?.result?.time);
                        setEnableAttempt(true);
                        setBlock(true);
                        // handleOpen1();
                        handlePopOpen7();
                    } else {
                        ToastError({ message: data?.message })
                    }
                    setPasswordLoading(false)

                }
            } catch (error) {
                ToastError({ message: "Something wrong" })
            }
        }
    };

    const handleDisableTwoFA = async () => {
        try {
            setPasswordLoading(true)
            setLoading(true)
            const { data } = await api.post(`/user/disable-twofa`, { currentPassword: password });
            if (data.success) {
                dispatch(getUserDetail());
                ToastSuccess({ message: "2fa disabled" })
                setLoading(false);
                setDisabled(false);
                setPasswordLoading(false);
                handleCloseVerifyModal();


            } else {
                ToastError({ message: data?.message })
                setLoading(false)
                setDisabled(false)
                setPasswordLoading(false)



            }
        } catch (error) {
            ToastError({ message: "Something wrong" })
            setLoading(false)
            setDisabled(false)
            setPasswordLoading(false)



        }
    };

    const handleInputChange = (value, index) => {
        if (!/^\d*$/.test(value)) return; // Only allow numbers

        const updatedOtp = [...otp];
        updatedOtp[index] = value;
        setOtp(updatedOtp);
        setErrors({
            ...errors,
            otp: ""
        })

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }


    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus(); // Focus previous input when backspace is pressed
        }
    };


    const handle2VerifyPaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData("text");
        if (!new RegExp(`^[0-9]{${otp.length}}$`).test(text)) {
            return;
        }
        const digits = text.split("");
        setOtp(digits);
    };

    const validateOTP = () => {
        let formErrors = {};
        let isValid = true;
        const otpValues = otp.join("");

        if (otpValues.length !== 6) {
            formErrors.otp = "OTP cannot be empty";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const [loading, setLoading] = useState(false)

    const handleVerify2FA = async () => {
        if (validateOTP()) {
            try {
                setLoading(true)
                setEnableAttempt(false);
                const OTP = otp?.join("");
                const { data } = await api.post(`/user/2fa-verify`, {
                    method,
                    OTP,
                    type: "email",
                    verifyType: "Twofa-Enable",
                });
                if (data.success) {
                    handleCloseVerifyModal();
                    setPassword("")
                    // ToastSuccess({ message: data.message })
                    if (method === "email") {
                        ToastSuccess({ message: "2fa enabled for email verification" })

                    }
                    if (method === "google") {
                        ToastSuccess({ message: "2fa enabled for google authentication" })

                    }

                    dispatch(getUserDetail());
                    setOtp(new Array(6).fill(""));
                    if (method === "email") {
                        handleClose1();
                    }
                    if (method === "google") {
                        handleClose();
                    }
                    setEnableAttempt(false);
                    setLoading(false)

                } else {
                    setLoading(false)
                    ToastError({ message: data?.message })
                }
            } catch (error) {
                setLoading(false)
                ToastError({ message: "Something went wrong" })
            } finally {
                setLoading(false);
                setLoading(false)

            }
        }
    };

    const [resendLoading, setResendLoading] = useState(false)

    const handleResend = async () => {
        setErrors({

            otp: "",
        });
        const data = {
            type: "email",
            value: userDetail?.email,
            verifyType: "Twofa-Enable",

        };
        setResendLoading(true);
        const response = await resendOtp(data);
        if (response?.data?.success === true) {
            setOtp(new Array(6).fill(""));
            ToastSuccess({ message: response?.data?.message })

            setTargetTime(response?.data?.result?.time);
            setTimerExpired(false);
            setResendLoading(false);
        } else {
            if (response?.data?.result?.blocked === true) {
                setEnableAttempt(true);
                handleOpen1();
                setTargetTime(response?.data?.result?.time);
            } else {
                ToastError({ message: response?.data?.message })
            }
            setResendLoading(false);
        }
    };

    const CountdownTimer = ({ timestamp, setTimerExpired }) => {
        const location = useLocation();
        const targetTimestamp = timestamp || location?.state?.data;

        // Redirect to home if no timestamp is passed
        useEffect(() => {
            if (!targetTimestamp) {
                // navigate("/");
            }
        }, [targetTimestamp]);

        // Calculate remaining time in seconds
        const calculateRemainingTime = () => {
            const now = Date.now();
            return Math.max(Math.floor((targetTimestamp - now) / 1000), 0);
        };

        const [count, setCount] = useState(calculateRemainingTime());

        useEffect(() => {
            // Stop when countdown reaches 0
            if (count <= 0) {
                setTimerExpired(true);
                return;
            }

            const interval = setInterval(() => {
                setCount(calculateRemainingTime()); // Update countdown
            }, 1000);

            return () => clearInterval(interval); // Cleanup
        }, [count]);

        const formatTime = (seconds) => {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${String(minutes).padStart(2, "0")}m:${String(secs).padStart(
                2,
                "0"
            )}s`;
        };

        return <p className="timer">{formatTime(count)}</p>;
    };
    return (
        <div>
            <Box sx={{ display: "block" }}>
                <div className="display-2 mb-20">
                    <h2 className="gold-color">Security Settings</h2>
                </div>

                <Grid container spacing={2} className="card-box">
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <h3>Two-Factor Authentication (2FA)</h3>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div style={{ display: "flex", flexDirection: md ? "column" : "row", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ display: "flex", flexDirection: md ? "column" : 'row', alignItems: "center", gap: '15px' }}>
                                <div>
                                    <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_911_10347)">
                                            <g clip-path="url(#clip1_911_10347)">
                                                <path d="M26.3379 52.6758C40.8839 52.6758 52.6758 40.8839 52.6758 26.3379C52.6758 11.7919 40.8839 0 26.3379 0C11.7919 0 0 11.7919 0 26.3379C0 40.8839 11.7919 52.6758 26.3379 52.6758Z" fill="white"></path>
                                                <path d="M13.4299 29.7946C13.4299 30.0389 13.4144 30.2498 13.4328 30.4582C13.4717 30.8989 13.8195 31.1777 14.3188 31.1781C16.2601 31.1796 18.2012 31.1796 20.1421 31.1781H29.8861C30.2418 31.1781 30.432 31.2959 30.4852 31.5482C30.5502 31.8543 30.3204 32.0992 29.9544 32.0994C28.7148 32.102 27.4753 32.1023 26.2358 32.1003H25.9012V35.7917H26.2093C27.4586 35.7917 28.7078 35.7831 29.9567 35.8023C30.0471 35.8109 30.1348 35.8374 30.2148 35.8803C30.2948 35.9232 30.3654 35.9816 30.4226 36.052C30.4558 36.1217 30.4715 36.1984 30.4681 36.2756C30.4647 36.3527 30.4425 36.4278 30.4033 36.4942C30.3492 36.557 30.283 36.6081 30.2085 36.6444C30.134 36.6807 30.0529 36.7014 29.9702 36.7052C26.1745 36.7167 22.3786 36.7195 18.5826 36.7136C18.2439 36.7136 18.038 36.5317 18.0383 36.2522C18.0386 35.9727 18.2465 35.7914 18.5837 35.7914C19.7846 35.79 20.9859 35.79 22.1874 35.7914H22.6333V32.1022H22.1435L14.3307 32.1005C13.2339 32.1005 12.5015 31.3722 12.5011 30.2807C12.5011 26.1006 12.5011 21.9204 12.5011 17.7402C12.4925 17.5041 12.5326 17.2687 12.6188 17.0486C12.705 16.8286 12.8354 16.6286 13.0021 16.4611C13.1689 16.2936 13.3682 16.1621 13.5878 16.0749C13.8075 15.9877 14.0427 15.9465 14.2789 15.954C20.9192 15.954 27.5595 15.954 34.1998 15.954C35.298 15.954 36.0274 16.6794 36.0298 17.7727C36.0314 18.3685 36.0326 18.9646 36.028 19.56C36.0261 19.9003 35.8495 20.1041 35.5675 20.1044C35.2856 20.1048 35.1088 19.8998 35.107 19.56C35.1043 18.9641 35.1077 18.3683 35.1053 17.7727C35.1034 17.1995 34.7854 16.8766 34.2156 16.8766C27.5856 16.8766 20.9552 16.877 14.3245 16.8778C13.7566 16.8778 13.4267 17.1893 13.4262 17.7331C13.4239 21.3848 13.4234 25.0363 13.4247 28.6878C13.4247 28.7351 13.4294 28.7823 13.4332 28.8568C13.529 28.8619 13.6212 28.8701 13.7133 28.8701C19.0947 28.8708 24.4762 28.8722 29.8579 28.8746C30.0092 28.869 30.1596 28.9009 30.2956 28.9674C30.3811 29.0152 30.4461 29.0928 30.4781 29.1854C30.5101 29.2779 30.507 29.379 30.4693 29.4695C30.4416 29.5681 30.3808 29.6541 30.2971 29.7131C30.2134 29.7721 30.1119 29.8004 30.0098 29.7933C29.2597 29.7933 28.5112 29.7933 27.7603 29.7933C23.071 29.7933 18.3816 29.7933 13.6922 29.7933C13.6181 29.7946 13.5424 29.7946 13.4299 29.7946ZM23.5969 32.1118V35.7774H24.9408V32.1118H23.5969Z" fill="black"></path>
                                                <path d="M40.1792 28.9043C40.1798 31.0181 40.1798 33.1323 40.1792 35.247C40.1782 36.1315 39.5995 36.7163 38.7234 36.7172C36.7719 36.7194 34.8209 36.7194 32.8706 36.7172C32.0054 36.7155 31.4158 36.1329 31.4158 35.2751C31.4136 31.0088 31.4136 26.742 31.4158 22.4745C31.4062 22.284 31.4365 22.0936 31.5046 21.9154C31.5727 21.7372 31.6772 21.5752 31.8114 21.4397C31.9456 21.3041 32.1066 21.198 32.2841 21.1281C32.4616 21.0583 32.6517 21.0261 32.8423 21.0338C34.8127 21.0304 36.7828 21.0304 38.7527 21.0338C39.5916 21.0353 40.1778 21.629 40.179 22.4751C40.181 24.618 40.181 26.761 40.1792 28.9043ZM39.2376 33.4734V23.8223H32.3511V33.4734H39.2376ZM32.337 34.4217C32.337 34.7349 32.3309 35.0219 32.3388 35.3078C32.3345 35.373 32.3443 35.4384 32.3674 35.4995C32.3905 35.5607 32.4265 35.6161 32.4729 35.6622C32.5193 35.7082 32.575 35.7438 32.6364 35.7664C32.6977 35.789 32.7632 35.7982 32.8284 35.7934C33.106 35.8005 33.3852 35.7951 33.6636 35.7951C35.3339 35.7951 37.0043 35.7951 38.6747 35.7951C39.0198 35.7951 39.227 35.6671 39.2458 35.3996C39.2696 35.0782 39.2512 34.7544 39.2512 34.4217H32.337ZM39.2569 22.8681C39.2569 22.7724 39.2569 22.7062 39.2569 22.6399C39.2614 22.0885 39.1316 21.9558 38.5887 21.9553H37.2925C35.8238 21.9553 34.355 21.9557 32.8862 21.9564C32.5319 21.9564 32.3523 22.1185 32.3378 22.4417C32.3323 22.5809 32.3368 22.7212 32.3368 22.8684L39.2569 22.8681Z" fill="black"></path>
                                                <path d="M30.0329 22.8893C30.0295 23.8927 29.7287 24.8726 29.1685 25.7051C28.6083 26.5376 27.8139 27.1854 26.8857 27.5666C25.9574 27.9477 24.9371 28.0452 23.9535 27.8466C22.9699 27.648 22.0672 27.1623 21.3596 26.4508C20.652 25.7394 20.1711 24.8341 19.9779 23.8495C19.7846 22.8649 19.8875 21.845 20.2737 20.9188C20.6598 19.9927 21.3119 19.2018 22.1474 18.6461C22.9829 18.0904 23.9645 17.7949 24.9679 17.7969C26.3137 17.8043 27.6018 18.344 28.5509 19.2982C29.4999 20.2524 30.0327 21.5435 30.0329 22.8893ZM29.1092 22.8738C29.1094 22.0545 28.8672 21.2535 28.413 20.5717C27.9589 19.8898 27.3131 19.3576 26.5571 19.042C25.8011 18.7264 24.9686 18.6415 24.1644 18.7981C23.3602 18.9547 22.6204 19.3457 22.038 19.9219C21.4556 20.4981 21.0568 21.2338 20.8916 22.0362C20.7265 22.8386 20.8025 23.672 21.1101 24.4313C21.4176 25.1907 21.943 25.8421 22.62 26.3034C23.2969 26.7648 24.0953 27.0156 24.9145 27.0241C25.4629 27.0286 26.0068 26.9246 26.5149 26.7182C27.023 26.5118 27.4852 26.2069 27.8751 25.8211C28.2649 25.4354 28.5746 24.9764 28.7864 24.4705C28.9982 23.9647 29.1079 23.4219 29.1092 22.8735V22.8738Z" fill="black"></path>
                                                <path d="M35.8026 31.638C35.2086 31.6378 34.628 31.4612 34.1344 31.1306C33.6409 30.8 33.2567 30.3302 33.0305 29.7809C32.8043 29.2316 32.7464 28.6275 32.8641 28.0452C32.9818 27.4629 33.2698 26.9287 33.6916 26.5104C34.1133 26.092 34.6498 25.8083 35.233 25.6954C35.8162 25.5824 36.4199 25.6452 36.9673 25.8758C37.5148 26.1063 37.9814 26.4943 38.3081 26.9905C38.6347 27.4867 38.8066 28.0688 38.8019 28.6628C38.7955 29.4541 38.4767 30.2107 37.9149 30.768C37.3531 31.3252 36.5939 31.6379 35.8026 31.638ZM37.8796 28.6506C37.8819 28.2399 37.7622 27.8377 37.5358 27.4951C37.3093 27.1524 36.9863 26.8846 36.6076 26.7256C36.2289 26.5667 35.8116 26.5236 35.4084 26.6019C35.0052 26.6803 34.6344 26.8764 34.3427 27.1657C34.0511 27.4549 33.8519 27.8241 33.7702 28.2266C33.6885 28.6291 33.7281 29.0468 33.884 29.4268C34.0398 29.8068 34.3049 30.1321 34.6457 30.3613C34.9865 30.5906 35.3876 30.7136 35.7983 30.7147C36.3476 30.7157 36.875 30.4991 37.265 30.1123C37.6551 29.7254 37.876 29.1999 37.8796 28.6506Z" fill="black"></path>
                                                <path d="M24.0312 24.5203C25.1 23.454 26.1401 22.4168 27.1805 21.379C27.2415 21.3181 27.3005 21.2553 27.3643 21.1963C27.5935 20.9854 27.8651 20.9761 28.0556 21.1714C28.2462 21.3668 28.2301 21.6297 28.0117 21.8611C27.8859 21.9939 27.754 22.1203 27.625 22.2491C26.5863 23.2883 25.5471 24.3272 24.5076 25.3658C24.1245 25.7491 23.946 25.7509 23.5706 25.3762C23.0267 24.8331 22.4835 24.2897 21.9411 23.7458C21.6849 23.4882 21.6583 23.22 21.8605 23.0144C22.0626 22.8089 22.3361 22.8305 22.5916 23.0836C23.0673 23.5562 23.5409 24.0309 24.0312 24.5203Z" fill="black"></path>
                                                <path d="M35.4215 28.7041C35.8136 28.3522 36.1984 28.0056 36.5847 27.6607C36.8488 27.425 37.1303 27.4157 37.3182 27.6322C37.4988 27.8416 37.4595 28.1117 37.2099 28.339C36.7395 28.7641 36.2678 29.1878 35.7947 29.6102C35.5104 29.8634 35.3242 29.8634 35.0369 29.6141C34.8203 29.4253 34.6038 29.2332 34.3934 29.0363C34.1638 28.8197 34.1418 28.5502 34.3285 28.3483C34.5088 28.1538 34.7632 28.1491 34.9985 28.34C35.0726 28.4001 35.1411 28.469 35.2138 28.5318C35.2781 28.5881 35.3451 28.6411 35.4215 28.7041Z" fill="black"></path>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_911_10347">
                                                <rect width="52.6758" height="52.6758" fill="white"></rect>
                                            </clipPath>
                                            <clipPath id="clip1_911_10347">
                                                <rect width="52.6758" height="52.6758" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className="twofa-txt text">
                                    <p className="head">Google Authentication</p>
                                    <p className="sub">Use Google Authenticator to secure withdrawals and account modifications. </p>
                                </div>
                            </div>
                            <div className="blu-btn mt-20 text-center">
                                {userDetail?.twofa?.enable && userDetail?.twofa?.type === "Google-Authenticator" ? (
                                    <Button
                                        className=""
                                        onClick={() => { handleOpenVerifyModal(); setDisabled(true) }}
                                        disabled={loading === true}
                                        sx={{ width: '85px' }}
                                    >
                                        Disable
                                    </Button>
                                ) : (
                                    <Button
                                        className=""
                                        sx={{ width: '85px' }}
                                        onClick={() => { handleOpenVerifyModal(); setMethod("google") }}
                                    >
                                        Enable
                                    </Button>
                                )}
                            </div>
                        </div>


                        <Modal
                            open={open}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style} className="res-modal">
                                <div className="display-2">
                                    <h3 style={{ fontWeight: 900 }} >GOOGLE AUTHENTICATION</h3> <CancelRoundedIcon onClick={() => { handleClose(); setErrors({}); setOtp(new Array(6).fill("")); }} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                                </div>
                                {
                                    googleAuthSecret != null &&
                                    <>

                                        <p className="mt-30">Install google autheticator app in your mobile and scan QR Code (or) If you are unable to scan the QR code, please enter this code manually into the app</p>

                                        <div className="input-common mt-20"
                                            component="form"
                                            style={{

                                                display: 'flex',
                                                alignItems: 'center',
                                                maxWidth: "100%",
                                                margin: "0 auto",
                                                border: '1px solid var(--color-BasicBg)',
                                                borderRadius: "8px"
                                            }}
                                        >
                                            <InputBase
                                                sx={{ ml: 1, flex: 1, marginTop: "0px !important" }}
                                                id="copyInput"
                                                // value={text}
                                                // onChange={handleInputChange}
                                                value={googleAuthSecret}
                                                inputProps={{ 'aria-label': 'search google maps' }}
                                            />
                                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                            <IconButton color="primary" sx={{ p: '5px' }} aria-label="directions">
                                                <ContentCopyRoundedIcon onClick={() => { handleCopy(); handlecopystate(); }} sx={{ color: "black" }} />
                                            </IconButton>
                                        </div>
                                    </>
                                }
                                <div className="input-common mt-10">
                                    <h3 style={{ fontWeight: 600 }}>Enter the 6-digit code from your Google Authenticator app</h3>

                                    <p style={{ fontSize: "13px", color: "#666", marginTop: "5px", textAlign: "center" }}>
                                        Open the Google Authenticator app and enter the current 6-digit verification code displayed for this account.
                                    </p>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "20px", gap: '15px' }}>
                                        {otp.map((value, index) => (
                                            <Grid2 item key={index}>
                                                <TextField
                                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                                    autoFocus={index === 0}
                                                    value={value}
                                                    onChange={(e) => handleInputChange(e.target.value, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handle2VerifyPaste}
                                                    inputProps={{
                                                        maxLength: 1,
                                                        style: {
                                                            textAlign: "center",
                                                            fontSize: "18px",
                                                            width: "20px",
                                                            height: "20px",
                                                            borderRadius: "4px",
                                                            background: "transparent",
                                                            padding: 5,
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    sx={{
                                                        "& input": {
                                                            color: "#fff",
                                                            margin: "5px",
                                                            backgroundColor: "#fff",
                                                            caretColor: "#fff",
                                                            "-webkit-text-fill-color": "#fff",
                                                            "&:autofill": {
                                                                backgroundColor: "#fff !important",
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid2>
                                        ))}
                                    </div>

                                    <div style={{ textAlign: "center" }}>
                                        <InputError error={errors.otp} />
                                    </div>
                                </div>

                                <div className="mt-20 text-center">

                                    <img
                                        src={qrCode}
                                    />
                                </div>
                                <div className="blu-btn text-center mt-20">
                                    {loading === true ?
                                        <Button sx={{ width: '85px' }} className="">Progressing</Button>
                                        :
                                        <Button onClick={() => {
                                            handleVerify2FA();
                                        }} className="" sx={{ width: '85px' }}>Submit</Button>
                                    }
                                </div>
                            </Box>
                        </Modal>

                    </Grid>
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div className="display-3">
                            <p style={{ fontWeight: 600, fontSize: "20px" }}>OR</p>
                        </div>
                        <Modal
                            open={open2}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style} className="res-modal">
                                <div className="display-2">
                                    <h2 className="gold-color" style={{ fontWeight: 900 }}>Verify Your Account</h2>
                                    <CancelRoundedIcon onClick={handleCloseVerifyModal} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                                </div>

                                <div className="input-common mt-30">
                                    {
                                        disabled === true ?



                                            <p style={{ fontSize: "14px", color: "#666", marginTop: "10px", textAlign: "center" }}>

                                                To continue disabled Two-Factor Authentication (2FA), please enter your current account password.<br /> <br />
                                                Once your password is verified, the selected verification method will be disabled.
                                            </p>
                                            :
                                            (method === "email" ?


                                                <p style={{ fontSize: "14px", color: "#666", marginTop: "10px", textAlign: "center" }}>

                                                    To continue enabling Two-Factor Authentication (2FA), please enter your current account password.<br />
                                                    Once the password is verified, a 6-digit OTP will be sent to your registered email address for confirmation.
                                                </p>
                                                :
                                                <p style={{ fontSize: "14px", color: "#666", marginTop: "10px", textAlign: "center" }}>
                                                    To continue enabling Two-Factor Authentication (2FA), please enter your current account password.<br />
                                                    Once your password is verified, a 6-digit code from your Google Authenticator app will be required to complete the setup.
                                                </p>)
                                    }


                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "20px" }}>
                                        <TextField
                                            name="password"
                                            type={showConfirmPassword ? "text" : "password"}
                                            fullWidth
                                            placeholder="Enter your current password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            error={!!errors.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label={showConfirmPassword ? "hide password" : "show password"}
                                                            onClick={handleClickShowConfirmPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            onMouseUp={handleMouseUpPassword}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>

                                    <div style={{ textAlign: "center" }}>
                                        <InputError error={errors.password} />
                                    </div>
                                </div>


                                <div className="blu-btn text-center mt-20">
                                    {passwordLoading === true ? <Button sx={{ width: '100px' }} className="">Progressing</Button> :
                                        (disabled === true ?
                                            <Button onClick={() => handleDisableTwoFA()} className="" sx={{ width: '85px' }}>Submit</Button> :
                                            <Button onClick={() => handleOpenTwoFA('email', method)} className="" sx={{ width: '85px' }}>Submit</Button>
                                        )
                                    }
                                </div>
                            </Box>
                        </Modal>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div style={{ display: "flex", flexDirection: md ? "column" : "row", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ display: "flex", flexDirection: md ? "column" : 'row', alignItems: "center", gap: '15px' }}>
                                <div>
                                    <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_911_10367)">
                                            <g clip-path="url(#clip1_911_10367)">
                                                <path d="M26.3379 52.6758C40.8839 52.6758 52.6758 40.8839 52.6758 26.3379C52.6758 11.7919 40.8839 0 26.3379 0C11.7919 0 0 11.7919 0 26.3379C0 40.8839 11.7919 52.6758 26.3379 52.6758Z" fill="white"></path>
                                                <path d="M26.4932 36.2187H16.1589C14.3029 36.2187 13.1642 35.0818 13.1641 33.2264C13.1641 28.6262 13.1641 24.026 13.1641 19.4257C13.1641 17.6127 14.3109 16.4611 16.116 16.4609C22.9366 16.4609 29.757 16.4609 36.5774 16.4609C38.3615 16.4609 39.5136 17.6149 39.5142 19.4061C39.516 24.1324 39.516 28.8584 39.5142 33.5843C39.5142 35.2317 38.533 36.2169 36.8938 36.2175C33.4271 36.2201 29.9603 36.2205 26.4932 36.2187ZM14.2625 18.8329C14.2528 19.0449 14.2412 19.1764 14.2412 19.3079C14.2397 20.6014 14.2397 21.8948 14.2412 23.1881C14.2412 26.5877 14.2406 29.9874 14.2395 33.3873C14.2147 33.8036 14.3561 34.2128 14.6328 34.525C14.7198 34.462 14.795 34.4107 14.8659 34.3549C17.2222 32.4827 19.5783 30.6103 21.9341 28.7379C22.2026 28.5232 22.4657 28.3022 22.7458 28.1037C22.7979 28.0622 22.8579 28.0317 22.9222 28.0142C22.9865 27.9967 23.0537 27.9926 23.1197 28.002C23.1857 28.0114 23.249 28.0342 23.3059 28.069C23.3627 28.1038 23.4119 28.1498 23.4503 28.2043C23.495 28.2533 23.5295 28.3107 23.5519 28.3732C23.5742 28.4357 23.584 28.502 23.5805 28.5682C23.5771 28.6345 23.5605 28.6994 23.5318 28.7593C23.5031 28.8191 23.4628 28.8726 23.4133 28.9168C23.3222 29.0036 23.2256 29.0845 23.1241 29.159C20.7497 31.0448 18.3753 32.9311 16.0009 34.8179C15.8996 34.8991 15.8044 34.9868 15.6678 35.1045H37.4757C37.3199 34.9788 37.2355 34.9056 37.1466 34.8388C35.2524 33.4173 33.3579 31.9962 31.4629 30.5754C30.7582 30.0468 30.0499 29.5237 29.3506 28.9869C29.0722 28.7739 29.0274 28.4853 29.2038 28.2343C29.3879 27.9724 29.6861 27.9337 29.9888 28.135C30.0458 28.173 30.0983 28.2172 30.1532 28.2587C32.7722 30.2211 35.3912 32.1836 38.0102 34.1461C38.1061 34.2178 38.2085 34.2806 38.3161 34.353C38.4612 33.9759 38.4959 19.2576 38.3567 18.8782C38.2451 18.971 38.1401 19.0541 38.0397 19.1411C34.3221 22.3496 30.6056 25.5587 26.8904 28.7683C26.416 29.1785 26.2684 29.1794 25.8048 28.7785C22.0712 25.5541 18.3377 22.3298 14.6043 19.1057C14.5129 19.0289 14.4172 18.9569 14.2625 18.8329ZM37.8147 17.9214C37.499 17.6505 37.0907 17.512 36.6753 17.5348C32.4534 17.5376 28.2314 17.5381 24.0092 17.5365C21.3318 17.5365 18.6544 17.5365 15.9771 17.5365C15.7759 17.5245 15.5744 17.5526 15.3841 17.6191C15.1939 17.6857 15.0188 17.7894 14.8689 17.9242C18.7071 21.2384 22.5314 24.5403 26.3418 27.83C30.1804 24.515 33.9801 21.233 37.8147 17.9214Z" fill="black"></path>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_911_10367">
                                                <rect width="52.6758" height="52.6758" fill="white"></rect>
                                            </clipPath>
                                            <clipPath id="clip1_911_10367">
                                                <rect width="52.6758" height="52.6758" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className="twofa-txt">
                                    <p className="head">Email Verification</p>
                                    <p className="sub">Use your email to protect your account and transactions</p>
                                </div>

                            </div>
                            <div className="blu-btn mt-20 text-center" >
                                {userDetail?.twofa?.enable && userDetail?.twofa?.type === "Email" ? (
                                    <Button
                                        className=""
                                        onClick={() => { handleOpenVerifyModal(); setDisabled(true) }}
                                        disabled={loading === true}
                                        sx={{ width: '85px' }}
                                    >
                                        Disable
                                    </Button>
                                ) : (
                                    <Button
                                        className=""
                                        sx={{ width: '85px' }}
                                        onClick={() => { handleOpenVerifyModal(); setMethod("email") }}
                                    >
                                        Enable
                                    </Button>
                                )}
                            </div>
                        </div>
                        <Modal
                            open={open1}
                            // onClose={handleClose1}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style} className="twofa-modal res-modal">
                                <div className="display-2">
                                    <h3 style={{ fontWeight: 900, }} >EMAIL AUTHENTICATION</h3> <CancelRoundedIcon onClick={() => { handleClose1(); setOtp(new Array(6).fill("")); setErrors({}) }} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                                </div>

                                <div className="input-common mt-20">
                                    <p className="mt-30" style={{ fontSize: "14px", color: "#666", textAlign: "center" }}>
                                        A 6-digit authentication code has been sent to your registered email address: <strong>{userDetail?.email}</strong>.<br />
                                        Please enter the code below to verify your identity and complete the Two-Factor Authentication (2FA) process.
                                    </p>
                                    <div className="mt-20" style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "15px" }}>
                                        {otp.map((value, index) => (
                                            <Grid2 item key={index}>
                                                <TextField
                                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                                    autoFocus={index === 0} // Autofocus on the first input box
                                                    value={value}
                                                    onChange={(e) => handleInputChange(e.target.value, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    onPaste={handle2VerifyPaste}
                                                    inputProps={{
                                                        maxLength: 1,
                                                        style: {
                                                            textAlign: "center",
                                                            fontSize: "18px",
                                                            width: "20px",
                                                            height: "20px",
                                                            borderRadius: "4px",
                                                            background: "transparent",
                                                            padding: 10
                                                        },
                                                    }}
                                                    variant="outlined"
                                                    sx={{
                                                        "& input": {
                                                            color: "#fff",
                                                            backgroundColor: "#fff",
                                                            caretColor: "#fff",
                                                            "-webkit-text-fill-color": "#fff",
                                                            "&:autofill": {
                                                                backgroundColor: "#fff !important",
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid2>
                                        ))}

                                    </div>
                                    <div className="text-center"><InputError error={errors.otp} /></div>
                                </div>

                                <div className="text-center blu-btn ">
                                    {timeExpired ? (
                                        <Button
                                            onClick={handleResend}
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mt: 3, border: "none" }}
                                            disabled={resendLoading === true}
                                        >
                                            Resend OTP
                                        </Button>
                                    ) : (
                                        <CountdownTimer
                                            setTimerExpired={setTimerExpired}
                                            timestamp={targetTime}
                                        />

                                    )}
                                </div>

                                <div className="blu-btn text-center mt-20">
                                    {loading === true ?
                                        <Button className="" sx={{ width: '85px' }}>Progressing</Button>
                                        :
                                        <Button onClick={() => {
                                            handleVerify2FA();
                                        }} className="" sx={{ width: '85px' }}>Submit</Button>
                                    }
                                </div>
                            </Box>
                        </Modal>
                    </Grid>
                </Grid>
                <Modal
                    open={pop7}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style} className="res-modal">
                        <div className="display-2">
                            <h3 style={{ fontWeight: 900, }} >Maximun attempts</h3>
                            <CancelRoundedIcon onClick={() => { handlePopClose7() }} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                        </div>

                        <Grid2
                            container
                            justifyContent="center"
                            spacing={2}
                            sx={{ mt: 2 }}
                        >
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className="display-1 mt-20" style={{ justifyContent: "center" }} >
                                    <div className="text-center">
                                        <p>
                                            You’ve reached the maximum number of OTP attempts.
                                            Your account is blocked for{" "}
                                            <CountdownTimer
                                                setTimerExpired={setTimerExpired}
                                                timestamp={targetTime}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
            </Box>
        </div>
    );
}

export default TwoFAProfile;
